import React from "react";
import {
  Tv,
  Report,
  Person,
  Message,
  AddCircleOutline,
  ListAlt,
  People,
  VerifiedUser,
  NewReleases,
  History,
  LocationCity,
  LocalMall,
  LocalMovies,
  TheaterComedy,
  Public,
  Dashboard,
  Reviews,
  Person2Outlined,
  RateReview,
  RateReviewOutlined,
  Note,
  SpaceDashboard,
  MovieCreation,
  TvOutlined,
  NoteAlt,
  Groups,
  AdminPanelSettings,
  AccountCircle,
  TheatersRounded,
  Newspaper,
  Announcement,
  EventSeat,
  AdsClick,
  AdbSharp,
  ImageAspectRatio,
  SummarizeOutlined,
  BugReportSharp,
  MovieCreationOutlined,
  AppBlockingOutlined,
  ManageAccounts,
  SystemUpdateAlt,
} from "@mui/icons-material";

const menus = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: <Dashboard />,
  },
  {
    label: "Movies",
    path: "/movies",
    icon: <TheaterComedy />,
    subMenu: [
      // {
      //   label: "Add New Movie",
      //   path: "/add-movie",
      //   icon: <AddCircleOutline />,
      // },
      { label: "Movie List", path: "/movies", icon: <ListAlt /> },
    ],
  },

  {
    label: "TV",
    icon: <Tv />,
    path: "/tv",
    subMenu: [
      // { label: "Programs", path: "/program", icon: <Tv /> },
      // { label: "Channels", path: "/channels", icon: <ListAlt /> },
      { label: "Channels", path: "/channels", icon: <Tv /> },
      // {
      //   label: "Add TV Program Schedule",
      //   path: "/add-tv-program-schedule",
      //   icon: <AddCircleOutline />,
      // },


    ],
  },
  {
    label: "Public Reports",
    icon: <Report />,
    path: "/public-reports",

  },
  {
    label: "Deputy Monitoring",
    path: "/deputies",
    icon: <RateReview />,
    subMenu: [
      { label: "Dashboard", path: "/dashboard", icon: <SpaceDashboard /> },
      { label: "No Reports", path: "/no-reports", icon: <AppBlockingOutlined /> },
      { label: "Summary", path: "/summary", icon: <SummarizeOutlined /> },
      { label: "Movie", path: "/reviews", icon: <MovieCreation /> },
      { label: "TV", path: "/tv-reports", icon: <TvOutlined /> },
      { label: "Others", path: "/other-reports", icon: <NoteAlt /> },
    ],
  },
  {
    label: "MTRCB Monitoring",
    path: "/mtrcb-monitoring",
    icon: <RateReview />,
    subMenu: [
      { label: "Movies", path: "/movies", icon: <MovieCreation /> },
    ],
  },
  {
    label: "Ticket Monitoring",
    path: "/tickets",
    icon: <MovieCreationOutlined />,
  },
  {
    label: "Users",
    path: "/hr",
    icon: <Groups />,
    subMenu: [
      // { label: "Deputy Register Request", path: "/deputy-register-request", icon: <Person /> },
      { label: "Verification", path: "/verify", icon: <VerifiedUser /> },
      { label: "Public", path: "/user", icon: <People /> },
      { label: "Deputies", path: "/deputy-user", icon: <AccountCircle /> },
      { label: "MTRCB", path: "/mtrcb-users", icon: <AdminPanelSettings /> },
      { label: "Admins", path: "/admin-users", icon: <ManageAccounts /> },
    ],
  },
  {
    label: "Message",
    icon: <Message />,
    path: "/messages",
    subMenu: [
      { label: "New Message", path: "/new-message", icon: <NewReleases /> },
      { label: "Message History", path: "/message-history", icon: <History /> },
    ],
  },
  {
    label: "Movie House",
    path: "/movie-house",
    icon: <LocalMovies />,
    subMenu: [
      { label: "Malls", path: "/malls", icon: <LocalMall /> },
      { label: "Theatres", path: "/theaters", icon: <TheatersRounded /> },
      // { label: "Cities", path: "/cities", icon: <LocationCity /> },

      // { label: "Theatres", path: "/theatres", icon: <LocalMovies /> },
      // { label: "movies schedule", path: "/movies-schedule", icon: <LocalMovies /> },
    ],
  },

  {
    label: "App Contents",
    path: "/app-contents",
    icon: <NoteAlt />,
    subMenu: [
      { label: "Officials", path: "/officials", icon: <Person2Outlined /> },
      { label: "Board Members", path: "/board-members", icon: <Person2Outlined /> },
      { label: "Committees", path: "/committees", icon: <Person2Outlined /> },
      { label: "Ratings", path: "/ratings/list", icon: <RateReviewOutlined /> },
      { label: "Press Releases", path: "/press-releases", icon: <Newspaper /> },
      { label: "Who is a Board Deputy", path: "/who-is-board", icon: <NoteAlt /> },
    ],
  },

  {
    label: "Updates",
    path: "/newsupdates",
    icon: <Announcement />,
    subMenu: [
      { label: "News", path: "/news", icon: <Newspaper /> },
      { label: "Events", path: "/events", icon: <EventSeat /> },
    ],
  },
  {
    label: "App Issues",
    path: "/appissues",
    icon: <BugReportSharp />,
  },
  {
    label: "Software Update",
    path: "/software-updates",
    icon: <SystemUpdateAlt />,
  },
];

export default menus;
